import { render, staticRenderFns } from "./StakeHeader.vue?vue&type=template&id=2d2b1459"
import script from "./StakeHeader.vue?vue&type=script&lang=js"
export * from "./StakeHeader.vue?vue&type=script&lang=js"
import style0 from "./StakeHeader.vue?vue&type=style&index=0&id=2d2b1459&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports